import { httpCreate } from './http';

const http = httpCreate('/srv/activityWatchCode');

export const activityWatchCode = {
	// 生成F码
	createWatchCode(activityId, numbers) {
		return http.get(`/create/${activityId}`, { params: { numbers: numbers } });
	},
	// 下载F码
	download(activityId, isUsed = 0) {
		return `${http.defaults.baseURL}/download/${activityId}/${isUsed}`;
	},
	// 导入名单
	import(activityId, data) {
		return http.post(`/import/${activityId}`, data);
	},
	// 生成单个指定名字
	addSingle(activityId, code) {
		return http.post(`/single/${activityId}`, { code: code });
	},
	delete(activityId, isUsed, whiteListIds) {
		return http.post(`/delete/${activityId}/${isUsed}`, whiteListIds);
	},
	clear(activityId) {
		return http.delete(`/clear/${activityId}`);
	},
	// 白名单列表
	whiteList(activityId, params) {
		return http.get(`/list/${activityId}`, { params: params });
	},
	// 白名单详情列表
	whiteDetailList(activityId, params) {
		return http.get(`/code/list/${activityId}`, { params: params });
	},
	//导出使用详情名单
	downloadByCode(activityId, code) {
		return `${http.defaults.baseURL}/downloadByCode/${activityId}/${code}`;
	},
	//删除复用的列表
	deleteReuse(id) {
		return http.delete(`/delete/${id}`);
	},
	// 清空白名单接口
	clearUsed(activityId) {
		return http.delete(`/clearUsed/${activityId}`);
	},
};
